/**
 * The live JWT lives in sessionStorage under `authToken`.
 *
 * A leftover `localStorage.authToken` is copied into sessionStorage once and
 * then deleted — it is never the live source after that. Tab-close must drop
 * the credential on a shared workstation.
 */
export function readAuthToken(): string | null {
  migrateLegacyTokenKey();

  const fromSession = sessionStorage.getItem('authToken');
  if (fromSession) {
    if (localStorage.getItem('authToken')) {
      localStorage.removeItem('authToken');
    }
    return fromSession;
  }

  const fromLocal = localStorage.getItem('authToken');
  if (fromLocal) {
    sessionStorage.setItem('authToken', fromLocal);
    localStorage.removeItem('authToken');
    return fromLocal;
  }

  return null;
}

function migrateLegacyTokenKey(): void {
  const sessionLegacy = sessionStorage.getItem('token');
  if (sessionLegacy && !sessionStorage.getItem('authToken')) {
    sessionStorage.setItem('authToken', sessionLegacy);
  }
  if (sessionLegacy) {
    sessionStorage.removeItem('token');
  }

  const localLegacy = localStorage.getItem('token');
  if (localLegacy) {
    if (!sessionStorage.getItem('authToken') && !localStorage.getItem('authToken')) {
      sessionStorage.setItem('authToken', localLegacy);
    }
    localStorage.removeItem('token');
  }
}
